import { useReveal } from "../hooks/useReveal";
import { useEventContent } from "../context/EventContentContext";
import { formatMarqueeChip } from "../lib/eventDisplay";

export function Marquee() {
  const ref = useReveal<HTMLDivElement>();
  const content = useEventContent();
  const chip = formatMarqueeChip(content.date);
  return (
    <div className="marquee" aria-hidden="true" ref={ref}>
      <div className="marquee-track">
        <span>An Overnight of Worship</span><i>✣</i>
        <span>One Night · One Voice · One Heaven</span><i>✣</i>
        <span>Dorothy Ashaba Live</span><i>✣</i>
        <span>Thobani Center · Kampala</span><i>✣</i>
        <span>{chip}</span><i>✣</i>
        <span>An Overnight of Worship</span><i>✣</i>
        <span>One Night · One Voice · One Heaven</span><i>✣</i>
        <span>Dorothy Ashaba Live</span><i>✣</i>
        <span>Thobani Center · Kampala</span><i>✣</i>
        <span>{chip}</span><i>✣</i>
      </div>
    </div>
  );
}
